import { EXCLUDED_FROM_MONTHLY_LIMIT_IDS } from '@/constants/categories';
import { BALANCE_IMPACTING_EDIT_STATUSES } from '@/constants/status';

import { IDashboardData } from '@/services/dashboard';

import type { IClaim } from '@/types/claim';

export interface ClaimEditAdjustment {
  balance: number;
  monthlyUsage: number;
}

/** Undo impact of an in-edit claim on dashboard balance / monthly usage for form limits. */
export function getClaimEditAdjustment(
  isEdit: boolean,
  claim: IClaim | null,
  dashboardData: Pick<IDashboardData, 'monthlyLimit'> | null | undefined,
): ClaimEditAdjustment {
  if (!isEdit || !claim || !dashboardData) {
    return { balance: 0, monthlyUsage: 0 };
  }

  const status = String(claim.status || '').toLowerCase();
  if (!BALANCE_IMPACTING_EDIT_STATUSES.has(status)) {
    return { balance: 0, monthlyUsage: 0 };
  }

  const excluded = EXCLUDED_FROM_MONTHLY_LIMIT_IDS.includes(claim.category);
  const { monthlyLimit } = dashboardData;
  const monthlyUsage = excluded ? 0 : Math.min(claim.amount, monthlyLimit);

  return {
    balance: claim.amount,
    monthlyUsage,
  };
}

export function sortClaimsByDate(claims: IClaim[]): IClaim[] {
  return [...claims].sort((a, b) => {
    if (!a.createdAt && !b.createdAt) return 0;
    if (!a.createdAt) return 1;
    if (!b.createdAt) return -1;
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  });
}
